import styled from 'styled-components'

export const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 1.69rem;
  height: 0.68rem;
  line-height: 0.61rem;
  background-image: url('${process.env.PUBLIC_URL}/icon-video/pay.png');
  background-size: 100% 100%;
`

export const Text = styled.div`
  margin-left: 0.57rem;
  margin-right: 0.57rem;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  text-align: left;
  font-size: 0.307rem;
`
